export function formatLapTime(durationMs: number | null | undefined) {
  if (durationMs === null || durationMs === undefined || durationMs <= 0) {
    return null;
  }

  const totalSeconds = durationMs / 1000;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds - minutes * 60;
  return `${minutes}:${seconds.toFixed(3).padStart(6, '0')}`;
}

export function bestLapFromFileLaps(laps: Array<{ durationMs: number | null }>) {
  const bestMs = laps
    .map((lap) => lap.durationMs)
    .filter((value): value is number => value !== null && value > 0)
    .sort((left, right) => left - right)[0];

  return formatLapTime(bestMs);
}
